module.exports = __webpack_public_path__ + "static/media/anu.7544acf0.jfif";